import moment from 'moment';

const getTime = datetime => moment.utc(new Date(datetime)).format('h:mm A');

export default ({ startDatetime, endDatetime }) => {
	const timeSlot = `${getTime(startDatetime)} - ${getTime(endDatetime)}`;
	return {
		display: timeSlot,
		value: timeSlot,
		enabled: true
	};
};
